import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Menu } from "antd";
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import logo from "../../../assets/logo.png";
import LogoutModal from "../../LogoutModal/LogoutModal";
import logout from "../../../service/logout";

const StudentRouting = ({ menuItems, handleClick, activeElement }) => {
  const [showModal, setShowModal] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();

  const toggleCollapsed = () => setCollapsed(!collapsed);

  const processMenuItems = (items) =>
    items.map((item) => {
      const IconComponent =
        activeElement === item.key ? item.activeIcon : item.icon;
      return {
        key: item.key,
        icon: <IconComponent className="w-6 h-6" />,
        label: <span className={collapsed ? "hidden" : ""}>{item.label}</span>,
        onClick: () => {
          handleClick && handleClick(item.key);
          item.path && navigate(item.path);
        },
      };
    });

  return (
    <div
      className={`flex flex-col h-screen transition-all duration-300 ${
        collapsed ? "w-20" : "w-64"
      }`}
    >
      <Menu
        mode="inline"
        theme="light"
        selectable={false}
        items={[
          {
            key: "toggle",
            icon: collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />,
            onClick: toggleCollapsed,
            label: (
              <img
                src={logo}
                alt="Logo"
                className={collapsed ? "hidden" : "w-24 ml-6"}
              />
            ),
          },
        ]}
        className="border-b py-4"
      />

      <Menu
        mode="inline"
        theme="light"
        selectedKeys={activeElement ? [activeElement] : []} // controlled by Dashboard
        items={processMenuItems(menuItems)}
        className="flex-1 overflow-y-auto thin-scrollbar pt-4"
      />

      <Menu
        mode="vertical"
        theme="light"
        items={[
          {
            key: "logout",
            icon: <LogoutOutlined />,
            label: (
              <span className={collapsed ? "hidden" : "ml-2"}>Logout</span>
            ),
            onClick: () => setShowModal(true),
          },
        ]}
        className="border-t"
      />

      <LogoutModal
        showModal={showModal}
        closeModal={() => setShowModal(false)}
        handleLogout={logout}
      />
    </div>
  );
};

export default StudentRouting;
